import React from 'react';

import Button from '../../components/UI/Button';
import css from './VerifyFunding.module.scss';

interface Props {
  onClickOk: () => void;
}

const AchModal = ({ onClickOk }: Props) => {
  return (
    <div data-testid="ach-modal" className={css.openModal}>
      <div className={css.modal} data-e2e="funding-modal">
        <p className={css.achHeader}>We&apos;re verifying your bank</p>
        <p>
          In 1–3 business days, you will see two small deposits into your bank
          account. Use your Greenlight app to verify the deposits to finish
          linking your account.
        </p>
        <Button text="Continue" onClick={onClickOk} />
      </div>
    </div>
  );
};

export default AchModal;
